import React, { ReactElement, useState, useEffect } from "react";
import { Translate } from "react-redux-i18n";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { Box, Dialog, DialogTitle, DialogContent, Typography, Button } from "@mui/material";

import LoginForm from "components/appbar/Login";
import RegisterForm from "components/appbar/Register";
import FontAwesomeIcon from "../FontAwesomeIcon";
import ConfirmProceed from "../ConfirmProceed";
import CasinoGamesSearch from "components/casino_base/CasinoGamesSearch";
import CasinoLiveGamesSearch from "components/casinoLive/CasinoLiveGamesSearch";
import VirtualGamesSearch from "components/virtual/VirtualGamesSearch";
import { RevenuesMobile } from "components/wallet/RevenueRow";
import Betcodes from "components/coupon/Betcodes"
import TermsAndConditions from "../../appfooter/Terms&Conditions/TermsContainer";
import PaymentView from "components/payments/PaymentView";
import { closeDialog } from "redux/dialog/dialogSlice";
import { clearPayMethodContent } from "redux/payments/paymentsSlice";
import styles from "./styles.module.scss"
import ConfirmCancel from "../ConfirmCancel";
import ConfirmPayed from "../ConfirmPayed";
import PrintOdds from "components/sport/PrintOdds";
import WalletAccountUtilities from "components/wallet/WalletAccountUtilities";
import { handleScroll } from "services/utils";
import { WalletType } from "../../../redux/wallet/walletSlice";
import CreateEditWallet from "components/wallet/CreateEditWallet";
import { clearOddsToPrint } from "redux/sport/sportSlice";
import LoginHistoryTable from "components/wallet/LoginHistoryTable";
import WorkWithUs from "skins/betun365/workWithUs";
import MoveWallet, { ConfirmMove } from "../MoveWallet";
import Cashout from "../Cashout";
import { clearCashoutData } from "redux/coupon/couponSlice";
import RevenueDetail from "../RevenueDetails";
import ChangePassword from "../ChangePassword";

interface IProps {
  skinLogo?: string;
  stay?: any;
  handleLogout?: any;
}

function AppDialog({ skinLogo, stay, handleLogout }: IProps): ReactElement {
  // function AppDialog({ skinLogo, stay, handleLogout }: IProps): ReactElement {
  const dispatch = useAppDispatch();
  const isDialogOpen = useAppSelector(state => state.dialog.isDialogOpen);
  const dialogContent = useAppSelector(state => state.dialog.dialogContent);
  const dialogData = useAppSelector(state => state.dialog.dialogData);
  const payMethodContent = useAppSelector(state => state.payments.payMethodContent);
  const paymentResponsive = useAppSelector(state => state.payments.responsive);
  const walletType = useAppSelector((state) => state.config.walletType);
  const authWallet = useAppSelector(state => state.auth.authWallet);
  const authWalletTypeId = useAppSelector((state) => state.auth.authWallet?.wallet_type?.id);
  const cashoutState = useAppSelector(state => state.coupon.cashoutState)
  const isDesktopLayout = useAppSelector(state => state.layoutToggle.isDesktopLayout)
  const userName = useAppSelector(state => state.dialog.dialogData?.name)
  const [itemsToLoad, setItemsToLoad] = useState<number>(4);
  const [walletTypeOptions, setWalletTypeOptions] = useState<WalletType[] | undefined>(undefined);

  const handleClose = () => {
    dispatch(closeDialog())
    dialogContent === "idleTimer" ?
      stay()
      : dispatch(closeDialog())
    payMethodContent && dispatch(clearPayMethodContent())
    dialogContent === 'printOdds' && dispatch(clearOddsToPrint())
    dialogContent === "cashout" && dispatch(clearCashoutData())
  }
  useEffect(() => {
    if (dialogContent === "createUser") {
      const found = walletType?.find(
        (element: WalletType) => element.id === authWalletTypeId
      );
      const canContainWalletType = found?.can_contain_wallettype;
      const options: any = canContainWalletType?.map((opt: number) => {
        return walletType?.find((el: WalletType) => el.id === opt);
      });
      options && setWalletTypeOptions(options)
    }
  }, [walletType, authWalletTypeId, dialogContent])

  return (
    <Dialog
      fullScreen={
        (dialogContent === "network" &&
          (dialogData.dialogContent !== "formEditCreate" && dialogData.dialogContent !== "formAccountTransfer")
        ) ? true :
          paymentResponsive === "mobile"
            && dialogContent === "payments"
            && payMethodContent?.type === "link"
            ? true
            : false
      }
      open={isDialogOpen}
      maxWidth={
        (dialogContent === "betcodes") ?
          "md" :
          (dialogContent === "login" ||
            dialogContent === "register" ||
            dialogContent === "createUser" ||
            dialogContent === "loginHistory" ||
            (dialogContent === "network" &&
              (dialogData.dialogContent === "formEditCreate" || dialogData.dialogContent === "formAccountTransfer")
            )
          ) ?
            "sm"
            : dialogContent === "payments" ||
              dialogContent === "accountTransfer"
              ?
              "xs"
              : dialogContent === "printOdds" ?
                "lg"
                : false
      }
      fullWidth={
        dialogContent === "login" ||
        dialogContent === "betcodes" ||
        dialogContent === "payments" ||
        dialogContent === "accountTransfer" ||
        dialogContent === "printOdds" || dialogContent === "loginHistory" ||
        dialogContent === "network" &&
        true
      }
      PaperProps={isDesktopLayout ? { style: { position: "absolute", top: "5%" } } : {}}
      className={styles.dialog}
    >
      <DialogTitle className={styles.dialogTitle}>
        <Box>
          {
            dialogContent === "createUser" ?
              <Box className={styles.titleContainer}>
                <FontAwesomeIcon type="fas" name="wallet" margin={1.5} />
                <Typography className={styles.titleLabel}>
                  <Translate value="buttons.createuser" />
                </Typography>
              </Box>
              : dialogContent === "accountTransfer" ?
                <Box className={styles.titleContainer}>
                  <FontAwesomeIcon type="fas" name="money-bill-transfer" margin={1.5} />
                  <Typography className={styles.titleLabel}>
                    <Translate value="dialog.transfer" />
                  </Typography>
                </Box>
                : dialogContent === "printOdds" ?
                  <Box className={styles.titleContainer}>
                    <Typography className={styles.titleLabel}>
                      <Translate value="sport.printOddsTitle" />
                    </Typography>
                  </Box>
                  : dialogContent === "loginHistory" ?
                    <Box className={styles.titleContainer}>
                      <Typography className={styles.titleLabelLogin}>
                        login history  -&nbsp;
                        <Typography className={styles.titleLabelUserName}>{dialogData}</Typography>
                      </Typography>
                    </Box>
                    : dialogContent === "moveWallet" ?
                      <Box className={styles.titleContainer}>
                        <FontAwesomeIcon name="right-left" type="fa" margin={1.5} />
                        <Typography className={styles.titleLabel}>
                          <Translate value="moveWallet.moveWallet" />
                        </Typography>
                      </Box>
                      : dialogContent === "revenueDetail" ?
                        <Typography className={styles.titleLabel}><Translate value="revenue.dialogTitle" /> - {userName}</Typography>
                        : dialogContent === "newPassword" ? <Typography className={styles.titleLabel}><Translate value="dialog.changePassword" /></Typography>
                          : dialogContent === "revenue" ?
                            <Typography className={styles.titleLabel}>{dialogData.name}</Typography>
                            : ""
          }
        </Box>

        {dialogContent !== "confirmProceed" && cashoutState !== "confirm" &&
          <Box
            onClick={handleClose}
            className={styles.closeIcon}
          >
            <FontAwesomeIcon name="xmark" type="fas" />
          </Box>
        }
      </DialogTitle>
      <Box
        onScroll={(e) => dialogContent === "printOdds" && handleScroll(e, setItemsToLoad, itemsToLoad, 1)}
        className={styles.contentContainer}
      >
        <DialogContent className={`
        ${styles.dialogContainer} 
        ${dialogContent === "workWithUs" && styles.noPadding}
        ${dialogContent === "loginHistory" && styles.loginHistoryNoPaddingMobile}
        ${dialogContent === "network" &&
          (dialogData.dialogContent === "trxTable" || dialogData.dialogContent === "betTable" || dialogData.dialogContent === "revenue")
          && styles.networkMobileDialogContainer
          }
        `} >
          {dialogContent === "login" &&
            <LoginForm skinLogo={skinLogo} />
          }
          {dialogContent === "register" &&
            <RegisterForm skinLogo={skinLogo} referral={dialogData} />
          }
          {dialogContent === "confirmProceed" &&
            <ConfirmProceed />
          }
          {
            dialogContent === "casinoSearch" &&
            <Box className={styles.searchCasinoGameContainer}>
              <Typography className={styles.searchCasinoText}>
                <Translate value="search.searchCasino" />
              </Typography>
              <CasinoGamesSearch />
            </Box>
          }
          {
            dialogContent === "casinoSearchLive" &&
            <Box className={styles.searchCasinoGameContainer}>
              <Typography className={styles.searchCasinoText}>
                <Translate value="search.searchCasino" />
              </Typography>
              <CasinoLiveGamesSearch />
            </Box>
          }
          {
            dialogContent === "virtual" &&
            <Box className={styles.searchCasinoGameContainer}>
              <Typography className={styles.searchCasinoText}>
                <Translate value="search.searchCasino" />
              </Typography>
              <VirtualGamesSearch />
            </Box>
          }
          {
            dialogContent === "revenue" && dialogData &&
            <RevenuesMobile revenue={dialogData} />
          }
          {
            dialogContent === "terms" &&
            <TermsAndConditions />
          }
          {
            dialogContent === "payments" &&
            <PaymentView />
          }

          {
            dialogContent === "betcodes" &&
            <Betcodes />
          }
          {
            dialogContent === "cancel" &&
            <ConfirmCancel />
          }
          {
            dialogContent === "payed" &&
            <ConfirmPayed />
          }
          {
            dialogContent === "printOdds" &&
            <PrintOdds
              itemsToLoad={itemsToLoad}
              setItemsToLoad={setItemsToLoad} />
          }
          {
            dialogContent === "createUser" &&
            <CreateEditWallet
              walletId={authWallet?.id}
              walletTypeOptions={walletTypeOptions}
              setWallet={handleClose}
              isExpandClicked={false}
              // count={0}
              index={1}
              isWalletOpen={false}
              hasExpandIcon={false}
              action={"create"}
              handleCancel={handleClose}
            />
          }
          {
            dialogContent === "loginHistory" &&
            <LoginHistoryTable />
          }
          {
            dialogContent === "accountTransfer" &&
            <WalletAccountUtilities />
          }
          {dialogContent === "workWithUs" &&
            <WorkWithUs />
          }
          {
            dialogContent === "moveWallet" &&
            <MoveWallet />
          }
          {
            dialogContent === "confirmMove" &&
            <ConfirmMove />
          }
          {
            dialogContent === "cashout" &&
            <Cashout />
          }
          {
            dialogContent === "revenueDetail" &&
            <RevenueDetail />
          }
          {dialogContent === "newPassword" && <ChangePassword />}
          {dialogContent === "idleTimer" &&
            <>
              <Typography className={styles.idleTimerLabels}>
                <Translate value="dialog.idleInfo" />
              </Typography>
              <Typography className={styles.idleTimerLabels}>
                <Translate value="dialog.idleInfoQuestion" />
              </Typography>
              <Box className={styles.idleTimerButtons}>
                <Button variant="contained" color="success" onClick={stay} >
                  <Translate value="buttons.stayLogged" />
                </Button>
                <Button variant="contained" color="error" onClick={handleLogout} >
                  <Translate value="buttons.stayLogout" />
                </Button>
              </Box>
            </>
          }
        </DialogContent>
      </Box>
    </Dialog>
  )
}
export default AppDialog;